module.exports = __webpack_public_path__ + "media/images/portal/i-3-fb108ee6d3d0de9f16eb24474be752f7.png";